import { useTheme } from '@mui/material';
import * as Preact from 'preact';
import * as Hooks from 'preact/hooks';
import * as ConfigurePanel from '../C_ConfigurePanel';
import * as ProductDrawer from '../C_ProductDrawer';
import * as PropertySelectorContainer from '../C_PropertySelectorContainer';
import { isSmallScreen } from '../domain/theme/breakpoints';
import { useTranslations } from '../utils/TranslationsWrapper';
export var Component = function (p) {
    var _a;
    var t = useTranslations().t;
    var isSmall = isSmallScreen(useTheme());
    var resetOnClose = Hooks.useCallback(function () {
        p.setSelectedOptionId(null);
        p.onCloseClick();
    }, []);
    var resetOnBack = Hooks.useCallback(function () {
        p.setSelectedOptionId(null);
    }, []);
    var part = Hooks.useMemo(function () { var _a; return (_a = p.parts.find(function (productList) { return productList.metadata.id === p.selectedOptionId; })) !== null && _a !== void 0 ? _a : null; }, [p.selectedOptionId, p.parts]);
    var heroPart = Hooks.useMemo(function () { var _a; return (_a = p.heroProperties.find(function (propChoice) { return propChoice.name === p.selectedOptionId; })) !== null && _a !== void 0 ? _a : null; }, [p.selectedOptionId, p.heroProperties]);
    var trackCompatibility = function (value) {
        var compatibility = value === 0 ? 'compatible' : 'incompatible';
        p.trackCompatibility(compatibility);
    };
    return heroPart ? (Preact.h(PropertySelectorContainer.Component, { onCloseClick: resetOnClose, onBackClick: resetOnBack, onOptionClick: function (heroPropId, isCompatible) {
            p.onHeroPartOptionClick(heroPropId, heroPart.name, isCompatible);
            p.trackVariantSelection({ value: heroPropId });
            if (isSmall) {
                resetOnClose();
            }
        }, propertyOptions: heroPart.options || [], selectedProperty: ((_a = heroPart.options.find(function (o) { return o.status === 'active'; })) === null || _a === void 0 ? void 0 : _a.displayName) || '', title: (heroPart === null || heroPart === void 0 ? void 0 : heroPart.displayName) || '', reorderDimensions: p.reorderDimensions })) : part ? (Preact.h(ProductDrawer.Component, { productCards: part.productCards, selectedPartId: part.metadata.id, formatCurrency: p.formatCurrency, trackMoreInfo: p.trackMoreInfo, topNavigation: {
            onBackClick: resetOnBack,
            onCloseClick: resetOnClose,
            disableClose: p.disableClose,
        }, onTabChange: trackCompatibility, onProductCardClick: function (productId, price, isCompatible) {
            p.onProductCardClick(productId, part.metadata.id, price, isCompatible);
            if (isSmall) {
                resetOnClose();
            }
        }, hidePrice: p.hidePrice })) : (Preact.h(ConfigurePanel.Component, { parts: p.parts, confirmationButtonText: p.configurePanelConfirmationText, title: p.configurePanelTitle, extraContent: p.extraConfigureContent, onPartClick: function (id) {
            p.setSelectedOptionId(id);
        }, onCloseClick: resetOnClose, disableClose: p.disableClose, heroProperties: {
            heroProperties: p.heroProperties,
            onColourClick: function () { },
            onHeroPropsClick: function (id) {
                p.trackVariantCategory(id);
                p.setSelectedOptionId(id);
            },
            trackVariantSelection: p.trackVariantSelection,
            reorderDimensions: p.reorderDimensions,
        }, onHeroPartOptionClick: function (heroPropId, partId, isCompatible) {
            p.onHeroPartOptionClick(heroPropId, partId, isCompatible);
            if (isSmall) {
                resetOnClose();
            }
        }, reorderDimensions: p.reorderDimensions }));
};
